import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InfoHover from '../../../../shared-components/InfoHover';

/**
 * Every list on Admicity Lookups opens with the same heading. Where a school may reword the heading,
 * a pen beside it opens the wording in place.
 */
// hideTitle: only the 'i', where the button above already names the list (Maria, 20 October 2026)
const SectionHeading = ({title, help, onSave, testId, hideTitle}) => {
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState(title);

    useEffect(() => {
        setText(title);
    }, [title]);

    const save = async () => {
        await onSave(text.trim());
        setEditing(false);
    };

    return (
        <Box sx={{mb: 1}} data-testid={testId}>
            {editing
                ? (
                    <Stack direction={{xs: 'column', sm: 'row'}} spacing={1} alignItems={{sm: 'center'}}>
                        <TextField
                            size="small"
                            label="Heading"
                            value={text}
                            autoFocus
                            onChange={event => setText(event.target.value)}
                            sx={{minWidth: {sm: 420}}}
                            inputProps={{'data-testid': `${testId}-input`}}
                        />
                        <Button variant="contained" disabled={!text.trim()} onClick={save}>Save</Button>
                        <Button
                            variant="text"
                            onClick={() => {
                                setText(title);
                                setEditing(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </Stack>
                )
                : (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        {/* Maria, 20 October 2026: the same heading as on SIMS Lookups, with the explanation in an 'i' */}
                        {!hideTitle && <Typography sx={{fontWeight: 600, fontSize: 17}}>{title}</Typography>}
                        {help && <InfoHover text={help} testId={`${testId}-hover`}/>}
                        {onSave && (
                            <Tooltip title="Edit the heading">
                                <IconButton
                                    size="small"
                                    aria-label="Edit the heading"
                                    data-testid={`${testId}-edit`}
                                    onClick={() => setEditing(true)}
                                >
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                )}
        </Box>
    );
};

SectionHeading.propTypes = {
    title: PropTypes.string.isRequired,
    help: PropTypes.node,
    onSave: PropTypes.func,
    testId: PropTypes.string,
    hideTitle: PropTypes.bool
};

export default SectionHeading;
